module.exports = __webpack_public_path__ + "static/media/Choice-Supportive Bias, Post-Purchase Rationalization.5f96b8eb.jpg";